export default [
  'premier-league',
  'bundesliga',
  'ligue-1',
  'serie-a',
  'la-liga',
  'allsvenskan'
]